<template>
  <div>
    <div class="mr-b25">
      <el-row type="flex" justify="start">
        <div class="title-bar title-h4 dot-title mr-r5 mr-t7">IP 대역</div>
        <el-button size="mini" @click="onIpRangeSelectClick">IP대역 선택</el-button>
      </el-row>
      <div class="list form-list mr-t5">
        <el-form ref="summaryForm" label-width="120px">
          <el-form-item label="IP 대역 요약">
            <span v-html="ipRangeText"></span>
          </el-form-item>
        </el-form>
      </div>
      <w-ip-range-select-popup :type="type" @syncIp="syncIp" ref="ipRangeSelectPopup" />
    </div>
    <div class="mr-b25">
      <el-row type="flex" justify="start">
        <div class="title-bar title-h4 dot-title mr-r5 mr-t7">모델링 방식</div>
        <el-button size="mini" @click="onModelingSelectClick">모델링 선택</el-button>
      </el-row>
      <div class="list form-list mr-t5">
        <el-form ref="summaryForm" label-width="120px">
          <el-form-item label="모델링 요약">
            <span v-html="modelingText"></span>
          </el-form-item>
        </el-form>
      </div>
      <w-modeling-select-popup :type="type" @syncModeling="syncModeling" ref="modelingSelectPopup" />
    </div>
    <div>
      <div class="title-bar title-h4 dot-title">
        수집 프로토콜 설정
      </div>
      <el-checkbox v-model="protocol.checkIcmp">ICMP</el-checkbox>
      <el-checkbox v-model="protocol.checkLldp">LLDP</el-checkbox>
      <el-checkbox v-model="protocol.checkArp">ARP</el-checkbox>
      <el-checkbox :disabled="!protocol.checkArp" v-model="protocol.checkFdb">FDB</el-checkbox>
    </div>
  </div>
</template>

<script>
import { isNil, isEqual, isEmpty } from 'lodash';
import WModelingSelectPopup from '@/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/popup/ModelingSelectPopup';
import WIpRangeSelectPopup from '@/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/popup/IpRangeSelectPopup';
import MapAPI from '@/api/topologymap/common';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WAutotopologySettingView',
  components: {
    WIpRangeSelectPopup,
    WModelingSelectPopup,
  },
  props: {
    type: {
      type: String,
      default: 'setting',
    },
    scheduleData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      protocol: {
        checkIcmp: true,
        checkLldp: true,
        checkArp: true,
        checkFdb: true,
      },
      checkedIp: [],
      checkedModeling: [],
    };
  },
  computed: {
    ipRangeText() {
      let ipSearchText = '';
      if (this.checkedIp.length > 0) {
        this.checkedIp.forEach((object) => {
          if (isEqual(object.scanType, 'SPOT')) {
            const tempText = `[${this.scanTypeFormatter(object.scanType)}] ${object.startAddress} <br />`;
            ipSearchText = `${ipSearchText}${tempText}`;
          } else {
            let exceptAddress = '';
            if (!isNil(object.exceptStartAddress) && !isEqual(object.exceptStartAddress, '')) {
              exceptAddress = `(예외구간:${object.exceptStartAddress}~${object.exceptEndAddress}) `;
            }
            let tempText = null;
            if (isEqual(object.scanType, 'RANGE')) {
              tempText = `[${this.scanTypeFormatter(object.scanType)}] ${object.startAddress}~${object.endAddress} ${exceptAddress} <br />`;
            } else {
              tempText = `[${this.scanTypeFormatter(object.scanType)}] ${object.startAddress} / 서브넷:${object.endAddress} ${exceptAddress} <br />`;
            }
            ipSearchText = `${ipSearchText}${tempText}`;
          }
        });
      }
      return isEmpty(ipSearchText) ? '-' : ipSearchText;
    },
    modelingText() {
      let modelingText = '';
      if (this.checkedModeling.length > 0) {
        this.checkedModeling.forEach((object) => {
          if (isEqual(object.scanType, 'SPOT')) {
            const tempText = `스캔방식:${isNil(object.credentialName) ? '없음' : object.credentialName}<br />`;
            modelingText = `${modelingText}${tempText}`;
          } else {
            let tempText = null;
            if (isEqual(object.scanType, 'RANGE')) {
              tempText = `스캔방식:${isNil(object.credentialName) ? '없음' : object.credentialName}<br />`;
            } else {
              tempText = `스캔방식:${isNil(object.credentialName) ? '없음' : object.credentialName}<br />`;
            }
            modelingText = `${modelingText}${tempText}`;
          }
        });
      }
      return isEmpty(modelingText) ? '-' : modelingText;
    },
  },
  methods: {
    getAutotopologySettingData(returnType) {
      const scanIds = [];
      this.checkedIp.forEach((ip) => {
        scanIds.push(ip.scanId);
      });
      const credentialIds = [];
      this.checkedModeling.forEach((modeling) => {
        credentialIds.push(modeling.credentialId);
      });
      const returnValue = {};

      Object.assign(returnValue, {
        protocol: this.protocol,
        scanIds,
        credentialIds,
      });

      if (returnType === 'add') {
        const topologymap = {
          label: this.scheduleData.scheduleName,
          fillType: 'Solid Fill',
          customimageId: null,
          gridShowFlag: '0',
          gridSize: null,
          fillOptions: {
            color: '#ffffff',
            alpha: '1.00',
          },
          strokeOptions: {},
          copyMapId: null,
          isAutomap: true,
        };

        Object.assign(returnValue, {
          topologymap,
        });
      }
      return returnValue;
    },
    loadData(scheduleId) {
      MapAPI.getAutotopologyInfo({
        scheduleId,
      })
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.checkedIp = result.checkedIp;
            this.checkedModeling = result.checkedModeling;
            this.protocol = result.protocol;
          }
        })
        .catch(() => {
        });
    },
    init() {
      this.checkedIp = [];
      this.checkedModeling = [];
      this.protocol = {
        checkIcmp: false,
        checkLldp: false,
        checkArp: false,
        checkFdb: false,
      };
    },
    onIpRangeSelectClick() {
      this.$refs.ipRangeSelectPopup.open(this.scheduleData, this.checkedIp);
    },
    onModelingSelectClick() {
      this.$refs.modelingSelectPopup.open(this.scheduleData, this.checkedModeling);
    },
    syncIp(ip) {
      this.checkedIp = ip;
    },
    syncModeling(modeling) {
      this.checkedModeling = modeling;
    },
    scanTypeFormatter(value) {
      let result = null;
      if (!isNil(value)) {
        if (isEqual(value, 'SPOT')) {
          result = '단일 IP';
        } else if (isEqual(value, 'RANGE')) {
          result = 'IP 구간';
        } else {
          result = '서브넷마스크';
        }
      }
      return result;
    },
    /**
     * 스케쥴 상세내용
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    createScheduleContent(record) {
      let scheduleContent;
      switch (record.schedulePeriod) {
        case 'N':
          scheduleContent = `${getDateToString(record.scheduleStarttime, 'YYYY년 MM월 DD일 HH:mm')}수행`;
          break;
        case 'D': {
          let hourInfo = record.scheduleHour;
          let minInfo = record.scheduleMinute;
          if (record.scheduleHour < 10) {
            hourInfo = `0${record.scheduleHour}`;
          }
          if (record.scheduleMinute < 10) {
            minInfo = `0${record.scheduleMinute}`;
          }
          scheduleContent = `매일 ${hourInfo} : ${minInfo}마다 수행`;
          break;
        }
        case 'W': {
          const days = ['일', '월', '화', '수', '목', '금', '토'];

          let intervalDate;
          record.scheduleIntervalDate.split(',').forEach((date) => {
            if (isEmpty(intervalDate)) {
              intervalDate = days[parseInt(date, 10) - 1];
            } else {
              intervalDate += `, ${days[parseInt(date, 10) - 1]}`;
            }
          });
          let hourInfo = record.scheduleHour;
          let minInfo = record.scheduleMinute;
          if (record.scheduleHour < 10) {
            hourInfo = `0${record.scheduleHour}`;
          }
          if (record.scheduleMinute < 10) {
            minInfo = `0${record.scheduleMinute}`;
          }
          scheduleContent = `매주 ${intervalDate}요일 ${hourInfo} : ${minInfo}마다 수행`;
          break;
        }
        case 'M': {
          let hourInfo = record.scheduleHour;
          let minInfo = record.scheduleMinute;
          if (record.scheduleHour < 10) {
            hourInfo = `0${record.scheduleHour}`;
          }
          if (record.scheduleMinute < 10) {
            minInfo = `0${record.scheduleMinute}`;
          }
          scheduleContent = `매 ${record.scheduleIntervalMonth}월 ${record.scheduleIntervalDate}일에 ${hourInfo} : ${minInfo}마다 수행`;
          break;
        }
        default:
          scheduleContent = '-';
          break;
      }

      return scheduleContent;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/form/AutotopologySettingForm.vue